module.exports = __webpack_public_path__ + "media/images/research_data-b5f09855b0abd438e829dc92e5b59e20.jpg";